/*=========================================================================================
  File Name: moduleLanguageState.js
  Description: Language Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  identityCardExists: false,
  Opportunities:[],
 OpportunityFees: [],
 OpportunityDocuments:[],
    Opportunity:{},
    vatPercentage: 0,
}
